import Vue from 'vue'
import App from './App.vue'
import './weui.css'
import './index.css'
import VueRouter from 'vue-router'
import routes from './routers.js'
import { Toast } from 'vue-weui'
import { verifyToken } from './services/user'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

// 映入svg图标
import '@/iconfont/font.js'

Vue.use(VueAwesomeSwiper)

Vue.use(VueRouter)
Vue.use(Toast)

// 引入HkjToast
import HkjToast from '@/components/HkjToast/index.js'
Vue.use(HkjToast)

import { scrollBottom } from './directives/scrollBottom'
Vue.directive('scroll-bottom', scrollBottom)
const router = (new VueRouter({ routes, mode: 'history' }))
// router 路由拦截器
router.beforeEach((to, from, next) => {
  // 验证token 如果token过期跳转登录页面
  if (to.path === '/login') {
    next()
  } else {
    verifyToken().then(res => {
      if (res.code === 200) {
        // 有效
        if (to.path === '/login') {
          next({ path: '/' })
        } else {
          next()
        }

      } else {
        next({ path: '/login'})
      }
      
    }).catch(error => {
      console.log(error.msg)
      next({ path: '/login' })
    })
  }
  
})

const app = new Vue({
  render: h => h(App),
  router
}).$mount('#app')

window.hkj = app


